import { InjectionToken } from '@angular/core';
import { Store } from '@df/catalog/store/store';

declare module '@df/core/df-core.config' {
    export interface IDfConfig {
        gmaps?: {
            /**
             * Access key
             */
            key?: string;
        };
    }
}

export namespace GoogleMaps {
    export const API_JS_URL = 'https://maps.googleapis.com/maps/api/js';
    export const EMBED_URL = 'https://www.google.com/maps/embed/v1/';

    export const DEFAULT_OPTIONS: IAppConfig = {
        apiOptions: {
            callback: 'onGoogleMapsReady'
        },
        mapOptions: {
            center: {
                lat: 51.5069119,
                lng: -0.093252
            },
            zoom: 12
        },
        embedMapOptions: {
            zoom: 12,
            mode: 'place'
        }
    };

    export const OPTIONS = new InjectionToken<IAppConfig>('DF_MODULE_GOOGLE_MAPS_OPTIONS', {
        providedIn: 'root',
        factory: () => DEFAULT_OPTIONS
    });

    export interface IAppConfig {
        libraries?: string;
        apiOptions: IAppConfigApiOptions;
        storeToMarker?: (store: Store, options: google.maps.MarkerOptions) => IMarkerOptions;
        mapOptions: google.maps.MapOptions;
        embedMapOptions: IAppConfigEmbedOptions;
    }

    export interface IAppConfigApiOptions {
        libraries?: string;
        callback: string;
        key?: string;
    }

    export interface IAppConfigEmbedOptions {
        zoom: number;
        mode: string;
    }
    export type MarkerConverter = (store: Store, options: IMarkerOptions) => IMarkerOptions;

    export interface IMarkerOptions extends google.maps.MarkerOptions {
        info?: string;
        storeId?: number;
    }

    export interface IEmbedParameters {
        key: string;
        location?: number[];
        q?: string;
        center?: number[];
        zoom?: number;
        heading?: number;
        pitch?: number;
        fov?: number;
    }

    export interface ILocateRequest {
        /**
         * Any location to use with geelocation
         * Usually its postcode or region name.
         * Its kind of search term for geolocator
         */
        address: string;
        /**
         * Country code 2 char iso
         * GB for Britain (not UK)
         */
        country: string;
    }

    export interface ILocateCallResponse {
        /**
         * Formatted address taken from geocode api
         */
        formattedAddress: string;
        /**
         * Latitude
         */
        latitude: number;
        /**
         * Longitude
         */
        longitude: number;
        /**
         * Extra data from geocode api
         */
        extra: any;
        /**
         * Administrative info
         */
        administrativeLevels: any;
        /**
         * Zipcode of place
         */
        zipcode?: string;
        /**
         * City
         */
        city: string;
        /**
         * Country
         */
        country?: string;
        /**
         * Country code 2 char iso
         */
        countryCode?: string;
        /**
         * Provider used for geocoding
         */
        provider?: string;
    }

    export namespace Address {
        export interface IEntryData {
            name: string;
            value: string;
            order: number;
        }

        export const FIELDS = ['street_1', 'street_2', 'city', 'postcode', 'country_id', 'region', 'region_id'];
    }
}
